/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_Offer_CtaInputs */

const en_us2_profile_editors_split_offer_cta = /** @type {(inputs: Profile_Editors_Split_Offer_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate draft`)
};

const pt_br2_profile_editors_split_offer_cta = /** @type {(inputs: Profile_Editors_Split_Offer_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar rascunho`)
};

const es_419_profile_editors_split_offer_cta = /** @type {(inputs: Profile_Editors_Split_Offer_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar borrador`)
};

const pt_pt2_profile_editors_split_offer_cta = /** @type {(inputs: Profile_Editors_Split_Offer_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar rascunho`)
};

const fr_fr2_profile_editors_split_offer_cta = /** @type {(inputs: Profile_Editors_Split_Offer_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer un brouillon`)
};

const de_de2_profile_editors_split_offer_cta = /** @type {(inputs: Profile_Editors_Split_Offer_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf erstellen`)
};

const it_it2_profile_editors_split_offer_cta = /** @type {(inputs: Profile_Editors_Split_Offer_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera bozza`)
};

/**
* | output |
* | --- |
* | "Generate draft" |
*
* @param {Profile_Editors_Split_Offer_CtaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_offer_cta = /** @type {((inputs?: Profile_Editors_Split_Offer_CtaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_Offer_CtaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_offer_cta(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_offer_cta(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_offer_cta(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_offer_cta(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_offer_cta(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_offer_cta(inputs)
	return en_us2_profile_editors_split_offer_cta(inputs)
});
export { profile_editors_split_offer_cta as "profile-editors.split_offer_cta" }